export const events = ({ tracker, condition }) => {
  const gtag = tracker;
  const { userId } = condition;

  return {
    SUCCESS(data) {
      const { eventName, payload } = data;
      const type = 'event';
      gtag(type, eventName, payload);
    },
    FAIL(data) {
      const { eventName, payload } = data;
      const type = 'event';
      gtag(type, eventName, payload);
    },
    RESULT(data) {
      const { eventName, payload } = data;
      const type = 'event';
      gtag(type, eventName, payload);
    },
  };
};
